// src/Pages/CheckoutCancelled.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";

export default function CheckoutCancelled() {
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      px={2}
      textAlign="center"
    >
      <Typography variant="h4" gutterBottom>
        Checkout cancelled — nothing was charged
      </Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        You can upgrade or buy more hours any time from your dashboard.
      </Typography>
      <Box mt={3} display="flex" gap={2}>
        <Button variant="contained" onClick={() => navigate("/portal")}>
          Back to Portal
        </Button>
      </Box>
    </Box>
  );
}
